import { render } from "./StandingsView.vue?vue&type=template&id=4b9c7989"
import script from "./StandingsView.vue?vue&type=script&lang=js"
export * from "./StandingsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__